<template>
    <details class="detailed-activity-tracker" :open="isExpanded" @toggle="toggleWeeks">
        <summary class="total-container flexible-container" :class="{expanded: isExpanded}">
            <div class="total-container__text">{{ t('projectclient.activitytracker.total') }}</div>
            <div class="total-container__chevron-wrapper">
                <div class="total-container__text">{{ totalText }}</div>

                <VJoyIcon v-if="showWeeks" :name="'chevron-down'" size="xsmall" color="neutral" />
                <VJoyIcon v-else :name="'chevron-up'" size="xsmall" color="neutral" />
            </div>
        </summary>
        <div v-for="(week, index) in weeksArray" :key="index">
            <DetailedActivityTrackerWeek
                :week-number="index + 1"
                :week="week"
                :is-last="index === weeksArray?.length - 1"
                :worked-unit="workedUnit"
            />
        </div>
    </details>
</template>
<script setup lang="ts">
    import {ref} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import type {WorkedUnit} from '@api';
    import DetailedActivityTrackerWeek from './DetailedActivityTrackerWeek.vue';
    import type {WorkWeek} from '../../../types';
    import {useFormatTotalText} from '../../../utils';

    const {t} = useTranslation();

    const props = defineProps<{
        weeksArray: Array<WorkWeek[]>;
        workedUnit: WorkedUnit;
        totalTimeWorked: number;
    }>();

    const isExpanded = ref(true);
    const showWeeks = ref(true);

    const toggleWeeks = (event: any) => {
        showWeeks.value = !showWeeks.value;
        isExpanded.value = event.target.open;
    };
    const totalText = useFormatTotalText(props.totalTimeWorked, props.workedUnit);
</script>
<style lang="scss" scoped>
    .detailed-activity-tracker {
        margin-bottom: var(--joy-core-spacing-4);
        background-color: var(--joy-color-neutral-white);

        .total-container {
            border: 1px solid var(--joy-color-neutral-30);
            border-radius: var(--joy-core-radius-3);

            &.expanded {
                border-bottom-left-radius: var(--joy-core-radius-0);
                border-bottom-right-radius: var(--joy-core-radius-0);
                border-bottom: none;
            }

            &__text {
                font-weight: var(--joy-font-weight-bold);
                font-size: var(--joy-core-spacing-5);
                padding-right: var(--joy-core-spacing-5);
            }

            &__chevron-wrapper {
                display: flex;
                align-items: center;
            }
        }
    }
</style>
